/**
 * i18n — Русский (ru) ✅ COMPLETE
 */

const ru = {
  appTitle: 'Tarkov Money Maker 2',
  modeBadgePvp: 'PvP',
  modeBadgePve: 'PvE',
  modeBadgeSeason: 'Сезон 1',
  loading: 'Загрузка',
  filterSearchLabel: 'Поиск',
  filterSearchPlaceholder: 'Название предмета, Enter или клик…',
  filterSearchAddTerm: 'Добавить ещё термин…',
  filterSearchAdd: 'добавить',
  filterProfitLabel: 'Мин. прибыль',
  filterLevelLabel: 'Уровень игрока',
  filterOffersLabel: 'Мин. предложений',
  filterOffersDisabled: 'API не предоставляет кол-во предложений для этого режима. Фильтр отключён.',
  traderEnable: 'включить',
  traderDisable: 'отключить',
  intelNotBuilt: 'Не построен',
  intelLevel1: 'Уровень 1',
  intelLevel2: 'Уровень 2',
  intelLevel3: '-30% сбор за флю',
  colItem: 'Предмет',
  colBuyTrader: 'Купить у торговца',
  colSellTrader: 'Продать торговцу',
  colAction: 'Действие',
  colBestProfit: '★ Лучшая прибыль',
  colTraderFlea: 'Торговец→Флея',
  colFleaTrader: 'Флея→Торговец',
  colFlea: 'Флея',
  copyToast: 'Скопировано!',
  tooltipBuyPrices: 'Цены покупки у торговцев',
  tooltipSellPrices: 'Цены продажи',
  flea24h: 'Флея — 24ч',
  fleaCur: 'Текущая',
  fleaLow: 'Мин. 24ч',
  fleaAvg: 'Ср. 24ч',
  fleaHigh: 'Макс. 24ч',
  fleaOffers: 'предложений',
  recFTS: 'Купить на Флее → Продать торговцу',
  recBTF: 'Купить у торговца → Продать на Флее',
  cardBuy: 'Покупка',
  cardSell: 'Продажа',
  cardOffers: 'предложений',
  paginationOf: 'из',
  paginationPerPage: 'На стр.:',
  paginationPage: 'Стр.',
  paginationTapSort: 'Нажмите для сортировки',
  noItems: 'Выгодных предметов не найдено. Снизьте порог или активируйте больше торговцев.',
  chartTitle: 'Флея — снимок 24ч',
  chartNoData: 'Недостаточно данных',
  apiStatusTitle: 'Статус синхронизации',
  apiStatusOnline: 'tarkov.dev Online',
  apiStatusDegraded: 'tarkov.dev Деградировал',
  apiStatusOffline: 'tarkov.dev Offline',
  apiStatusChecking: 'Проверка…',
  apiStatusGlobal: 'Глобальный статус',
  apiStatusLastSync: 'Последняя sync',
  apiStatusItems: 'Синхронизировано предметов',
  apiStatusItemsSub: 'всего накоплено',
  apiStatusSource: 'Источник API',
  apiStatusSourceSub: 'авто-проверка каждые 30с',
  apiStatusCheckedAt: 'Проверено',
  apiStatusModeStatus: 'Статус',
  apiStatusModeItems: 'Предметы',
  apiStatusModeLastSync: 'Последняя sync',
  apiStatusModeDuration: 'Длительность',
  apiStatusNever: 'никогда',
  apiStatusJustNow: 'только что',
  apiStatusTimeAgoPrefix: '',
  apiStatusMinutesAgo: 'мин назад',
  apiStatusHoursAgo: 'ч назад',
  apiStatusRest: 'REST',
  exportCSV: 'Экспорт CSV',
  exportJSON: 'Экспорт JSON',
  histFleaPrice: 'Цена флеи — последние 24ч',
  histOffers: 'Предложения — последние 24ч',
  histLoading: 'Загрузка истории…',
  histNoData: 'История пока отсутствует — данные накапливаются после каждой синхронизации.',
  histError: 'Сервер недоступен — история появится после запуска бэкенда.',
};

export default ru;
